import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import moneyHelper from '../Helpers/moneyHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import OutsourcedStatusEnum from '../Enums/OutsourcedStatusEnum';
import AuthService from '../Services/authService';

export default class OutsourcedJobLinkItem {
  constructor(item) {
    if (item === undefined) {
      this.OutsourcedJobLinkId = null;
      this.AssignmentId = null;
      this.TpJobId = null;
      this.UserId = null;
      this.UserName = '';
      this.FieldworkOfficeId = null;
      this.FieldworkOfficeName = '';
      this.OutsourcingOfficeId = null;
      this.OutsourcingOfficeName = '';
      this.Status = '';
      this.ThirdPartyJobId = '';
      this.ThirdPartySource = '';
      this.ClientId = null;
      this.ClientName = '';
      this.ThirdPartyClientId = '';
      this.ProjectId = null;
      this.ProjectName = '';
      this.SurveyName = '';
      this.SurveyId = null;
      this.TpSurveyId = null;
      this.ThirdPartySurveyId = '';
      this.WaveName = '';
      this.WaveId = null;
      this.TpWaveId = null;
      this.ThirdPartyWaveId = '';
      this.DateAssigned = null;
      this.OutsourcedFeeId = null;
      this.OutsourcedFeeAmount = null;
      this.OutsourcedFeeCurrencyCode = '';
      this.IobInvoiceId = null;
      this.FeeType = '';
    } else {
      this.initialize(item);
    }
    this.Selected = false;
  }

  initialize(item) {
    this.OutsourcedJobLinkId = item.outsourcedJobLinkId;
    this.AssignmentId = item.assignmentId;
    this.TpJobId = item.tpJobId;
    this.UserId = item.userId;
    this.UserName = item.userName ?? '';
    this.OutsourcingOfficeId = item.outsourcingOfficeId;
    this.OutsourcingOfficeName = (item.outsourcingOfficeName ?? '').replace('BARE ', '').trim();
    this.FieldworkOfficeId = item.fieldworkOfficeId;
    this.FieldworkOfficeName = (item.fieldworkOfficeName ?? '').replace('BARE ', '').trim();
    this.Status = item.status ?? '';
    this.ThirdPartyJobId = item.thirdPartyJobId ?? '';
    this.ThirdPartySource = item.thirdPartySource ?? '';
    this.ClientId = item.clientId;
    this.ClientName = item.clientName ?? '';
    this.ThirdPartyClientId = item.thirdPartyClientId ?? '';
    this.ProjectId = item.projectId;
    this.ProjectName = item.projectName ?? '';
    this.SurveyName = item.surveyName ?? '';
    this.SurveyId = item.surveyId;
    this.TpSurveyId = item.tpSurveyId;
    this.ThirdPartySurveyId = item.thirdPartySurveyId ?? '';
    this.WaveName = item.waveName ?? '';
    this.WaveId = item.waveId;
    this.TpWaveId = item.tpWaveId;
    this.ThirdPartyWaveId = item.thirdPartyWaveId ?? '';
    this.DateAssigned = item.dateAssigned;
    this.OutsourcedFeeId = item.outsourcedFeeId;
    this.OutsourcedFeeAmount = item.outsourcedFeeAmount;
    this.OutsourcedFeeCurrencyCode = item.outsourcedFeeCurrencyCode ?? '';
    this.IobInvoiceId = null;
    this.FeeType = item.feeType ?? '';
  }

  static NameOfTheIdField() {
    return 'OutsourcedJobLinkId';
  }

  static nameOfTheItemDetailList(item) {
    return `Outsourced Job Link (${item.ThirdPartyJobId})`;
  }

  static MoneyFields = ['OutsourcedFeeAmount'];

  static Currency() {
    return 'OutsourcedFeeCurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['DateAssigned'];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },

        { name: 'OutsourcedJobLinkId', label: 'ID' },
        { name: 'OutsourcingOfficeName', label: 'Work Done By' },
        { name: 'FieldworkOfficeName', label: 'Bill To Office' },

        {
          name: (item) =>
            item.OutsourcedFeeId
              ? moneyHelper.toMoneyFormat(item.OutsourcedFeeAmount, item.OutsourcedFeeCurrencyCode)
              : '',
          label: 'Fee',
        },
        { name: 'Status', label: 'Status' },
        { name: 'FeeType', label: 'Fee Type' },

        { name: 'IobInvoiceId', label: 'IOB Invoice ID' },

        { name: '-message-', label: 'Related Job Information', className: 'text-left' },

        { name: 'ThirdPartyJobId', label: 'Third Party Job ID' },
        { name: 'ThirdPartySource', label: 'Third Party Source' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDD(item.DateAssigned), label: 'Date Assigned' },

        // Bravo ids alongside the third-party ones: the grid columns show only the Bravo id now, so this panel
        // is where someone goes to find the Apollo or third-party one (CD-5079).
        { name: 'ClientName', label: 'Client Name' },
        { name: 'SurveyName', label: 'Survey Name' },
        { name: 'WaveName', label: 'Wave Name' },

        { name: 'ClientId', label: 'Client Bravo ID' },
        { name: (item) => item.TpSurveyId ?? item.SurveyId, label: 'Survey Bravo ID' },
        { name: 'WaveId', label: 'Wave Bravo ID' },

        { name: 'ThirdPartyClientId', label: 'Third Party Client ID' },
        { name: 'ThirdPartySurveyId', label: 'Third Party Survey ID' },
        { name: 'ThirdPartyWaveId', label: 'Third Party Wave ID' },

        { name: 'TpWaveId', label: 'TP Wave Bravo ID' },
        { label: '', name: '', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },

        { name: 'ProjectId', label: 'Project Bravo ID' },
        { name: 'ProjectName', label: 'Project Name' },
        { label: '', name: '', className: 'text-left' },

        { name: 'UserId', label: 'User Bravo ID' },
        { name: 'UserName', label: 'User Name' },
        { label: '', name: '', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: OutsourcedJobLinkItem.getSelectedCellHeader,
        orderById: '',
        data: OutsourcedJobLinkItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Third Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        type: FieldTypesEnum.PureDataField,
        minWidth: 60,
      },
      {
        label: 'Client (Bravo ID)',
        orderById: 'ClientName',
        data: OutsourcedJobLinkItem.getClientDisplay,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Survey (Bravo ID)',
        orderById: 'SurveyName',
        data: OutsourcedJobLinkItem.getSurveyDisplay,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Project (Bravo ID)',
        orderById: 'ProjectName',
        data: OutsourcedJobLinkItem.getProjectDisplay,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'User (Bravo ID)',
        orderById: 'UserName',
        data: OutsourcedJobLinkItem.getUserDisplay,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Work Done By',
        orderById: 'OutsourcingOfficeName',
        data: 'OutsourcingOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Bill To Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Fee',
        orderById: 'OutsourcedFeeAmount',
        data: (item) =>
          item.OutsourcedFeeId
            ? moneyHelper.toMoneyFormat(item.OutsourcedFeeAmount, item.OutsourcedFeeCurrencyCode)
            : '',
        type: FieldTypesEnum.PureDataField,
        minWidth: 60,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        type: FieldTypesEnum.PureDataField,
        minWidth: 80,
      },
      {
        label: 'Fee Type',
        orderById: 'FeeType',
        data: 'FeeType',
        type: FieldTypesEnum.PureDataField,
        minWidth: 80,
      },
      {
        label: ' ',
        orderById: '',
        data: OutsourcedJobLinkItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    const userOfficeId = AuthService.getInstance().GetLoggedInUser()?.officeId;
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-trash-can',
            text: 'Delete',
            roleKey: 'outsourced_joblinks_edit',
            disabled: item.Status === OutsourcedStatusEnum.Invoiced,
            onClick: () => OutsourcedJobLinkItem.deleteFunction(item.OutsourcedJobLinkId, item),
          },
          {
            iconName: 'fa-solid fa-ban',
            text: 'Mark as Uninvoiceable',
            roleKey: 'outsourced_joblinks_edit',
            hide: item.Status === OutsourcedStatusEnum.Uninvoiceable,
            disabled: item.Status === OutsourcedStatusEnum.Invoiced,
            onClick: () => OutsourcedJobLinkItem.markAsUninvoiceableFunction(item.OutsourcedJobLinkId, item),
          },
          {
            iconName: 'fa-solid fa-check-circle',
            text: 'Mark as Invoiceable',
            roleKey: 'outsourced_joblinks_edit',
            hide: item.Status !== OutsourcedStatusEnum.Uninvoiceable,
            onClick: () => OutsourcedJobLinkItem.markAsInvoiceableFunction(item.OutsourcedJobLinkId, item),
          },
          {
            iconName: 'fa-solid fa-building',
            text: 'Change Bill To Office',
            roleKey: 'outsourced_joblinks_edit',
            disabled:
              item.Status !== OutsourcedStatusEnum.Collected && item.Status !== OutsourcedStatusEnum.FeeAttached,
            onClick: () => OutsourcedJobLinkItem.changeFieldworkOfficeFunction(item.OutsourcedJobLinkId, item),
          },
          {
            iconName: 'fa-solid fa-unlink',
            text: 'Remove Fee',
            roleKey: 'outsourced_joblinks_edit',
            // Anything up to the invoice: a link that either office has already approved can still have the
            // wrong rate taken off it. It used to be Fee Attached only, and the server silently skipped the
            // rest rather than saying it had refused.
            disabled: item.Status === OutsourcedStatusEnum.Invoiced,
            onClick: () => OutsourcedJobLinkItem.removeFeeFunction(item.OutsourcedJobLinkId, item),
          },
          {
            iconName: 'fa-solid fa-check',
            text: 'Approve (Bill To Office)',
            roleKey: 'outsourced_joblinks_edit',
            disabled: item.Status !== OutsourcedStatusEnum.FeeAttached || item.FieldworkOfficeId !== userOfficeId,
            onClick: () => OutsourcedJobLinkItem.fwApproveFunction(item.OutsourcedJobLinkId),
          },
          {
            iconName: 'fa-solid fa-check-double',
            text: 'Approve (Work Done By)',
            roleKey: 'outsourced_joblinks_edit',
            disabled:
              item.Status !== OutsourcedStatusEnum.ReadyForInvoicing || item.OutsourcingOfficeId !== userOfficeId,
            onClick: () => OutsourcedJobLinkItem.osApproveFunction(item.OutsourcedJobLinkId),
          },
        ]}
      />
    );
  }

  static deleteFunction = (id, item) => {
    alert('Empty function');
  };

  static markAsUninvoiceableFunction = (id, item) => {
    alert('Empty function');
  };

  static markAsInvoiceableFunction = (id, item) => {
    alert('Empty function');
  };

  static changeFieldworkOfficeFunction = (id, item) => {
    alert('Empty function');
  };

  static removeFeeFunction = (id, item) => {
    alert('Empty function');
  };

  static fwApproveFunction = (id) => {
    alert('Empty function');
  };

  static osApproveFunction = (id) => {
    alert('Empty function');
  };

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          OutsourcedJobLinkItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={OutsourcedJobLinkItem.selectedStatus()}
        onChange={(e) => {
          OutsourcedJobLinkItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  // See OutsourcedFeeItem: the id in brackets is always the BRAVO id now, matching the Project and User
  // columns that already worked that way (CD-5079). The third-party ids are on the details panel.
  static getClientDisplay(item) {
    if (!item.ClientName && !item.ClientId) return '';
    return item.ClientId ? `${item.ClientName} (${item.ClientId})` : item.ClientName;
  }

  // A TP job names its survey directly; an Apollo assignment's legacy survey is resolved by Sassie id on the
  // server (OutsourcedJobLinkService.AdditionalMappingAsync), so both kinds can show a Bravo id here.
  static getSurveyDisplay(item) {
    const surveyId = item.TpSurveyId || item.SurveyId;
    if (!item.SurveyName && !surveyId) return '';
    return surveyId ? `${item.SurveyName} (${surveyId})` : item.SurveyName;
  }

  static getProjectDisplay(item) {
    if (!item.ProjectName && !item.ProjectId) return '';
    return item.ProjectId ? `${item.ProjectName} (${item.ProjectId})` : item.ProjectName;
  }

  static getUserDisplay(item) {
    if (!item.UserName && !item.UserId) return '';
    return item.UserId ? `${item.UserName} (${item.UserId})` : item.UserName;
  }
}
